import { HttpHeaders } from '@angular/common/http';

export const contentHeaders = new HttpHeaders({
  Accept: 'application/json',
  //'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'x-context',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE, PATCH',
  'x-context': 'default',
});
